import { Dialog, DialogContent, ListItem, ListItemText } from '@material-ui/core';
import { uniqueId } from 'lodash';
import React, { ReactNode, SyntheticEvent, useState } from 'react';
import T from 'src/components/content-manager/translator/T';
import DialogTitleWithClose from 'src/components/elements/DialogTitleWithClose';
import ShippingCostTable from 'src/components/shop/ShippingCostTable';

interface ShippingCostTableDiscoverProps {
    trigger?: (onClick: (e: SyntheticEvent) => void) => ReactNode;
}

const ShippingCostTableDiscover: React.FC<ShippingCostTableDiscoverProps> = ({ trigger }) => {
    const [open, setOpen] = useState(false);

    const id = uniqueId('dialog');

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {trigger ? (
                trigger(handleOpen)
            ) : (
                <ListItem button onClick={handleOpen}>
                    <ListItemText>
                        <T k="shop.shipping_cost_table_discover.action" />
                    </ListItemText>
                </ListItem>
            )}
            <Dialog disableEscapeKeyDown onClose={handleClose} aria-labelledby={id} open={open} maxWidth="lg">
                <DialogTitleWithClose onClose={handleClose} id={id} />
                <DialogContent>
                    <ShippingCostTable />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ShippingCostTableDiscover;
